import { queryOptions } from '@tanstack/react-query';

import { backendEndpoints } from '$/services/endpoints';
import { fetcher } from '$/services/fetcher';
import {
  GetAllCountriesSchema,
  GetCountryByIdSchema,
} from '$/services/usecases/internationalization/mapper/countries';

export const getAllCountries = async () => {
  return fetcher(backendEndpoints.COUNTRIES_URL, {
    method: 'GET',
    parser: (data) => GetAllCountriesSchema.parse(data),
  });
};

export const getCountryById = async (id: string) => {
  return fetcher(`${backendEndpoints.COUNTRIES_URL}/${id}`, {
    method: 'GET',
    parser: (data) => GetCountryByIdSchema.parse(data),
  });
};

export const countriesQuery = queryOptions({
  queryKey: ['countries'],
  queryFn: () => getAllCountries(),
  staleTime: 1000 * 60 * 10,
});

export const countryByIdQuery = (id: string, isDisabled: boolean) =>
  queryOptions({
    queryKey: ['countries', id],
    queryFn: () => getCountryById(id),
    staleTime: 1000 * 60 * 10,
    enabled: !isDisabled,
  });
